import { render, staticRenderFns } from "./ChzzkStreamerDetail.vue?vue&type=template&id=4067db43&scoped=true"
import script from "./ChzzkStreamerDetail.vue?vue&type=script&lang=js"
export * from "./ChzzkStreamerDetail.vue?vue&type=script&lang=js"
import style0 from "./chzzk.main.47bcbdf5.css?vue&type=style&index=0&id=4067db43&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4067db43",
  null
  
)

export default component.exports